export const HOST_GROWME = process.env.REACT_APP_HOST_GROWME;
export const DEFAULT_PASS = process.env.REACT_APP_DEFAULT_PASS;
export const TEST_ID = process.env.REACT_APP_TEST_ID;
export const AVAILABLE_TESTS = JSON.parse(process.env.REACT_APP_AVAILABLE_TESTS || "[]");

export const SECRET_KEY = process.env.REACT_APP_SECRET_KEY

export const MAINTENANCE_MODE = process.env.REACT_APP_MAINTENANCE_MODE === 'true';
export const MAINTENANCE_MESSAGE = process.env.REACT_APP_MAINTENANCE_MESSAGE?.trim() || 'Estamos en modo mantenimiento, volvemos pronto';

export const CAPTCHA_PROVIDER = process.env.REACT_APP_CAPTCHA_PROVIDER || 'disabled';
export const CAPTCHA_SITE_KEY = process.env.REACT_APP_CAPTCHA_SITE_KEY;
export const CAPTCHA_ENABLED = CAPTCHA_PROVIDER === 'turnstile' && !!CAPTCHA_SITE_KEY;

export const CONTACT_EMAIL = 'contacto@singulares.com';

export const ROUTES = {
  ROOT: {
    route: '/',
    name: 'Home'
  },
  HOME: {
    route: '/inicio',
    name: 'Inicio'
  },
  CLIENTS: {
    route: '/clients',
    name: 'Clientes'
  },
  USERS: {
    route: '/usuarios',
    name: 'Usuarios'
  },
  PROFILE: {
    route: '/perfil',
    name: 'Perfil'
  },
  LOGIN: {
    route: '/login',
    name: 'Login'
  },
  RECOVER: {
    route: '/recover',
    name: 'Recuperar Contraseña'
  },
  CONFIGURATION: {
    route: '/configuration',
    name: 'Configuraciones'
  }
  ,
  PARAMS: {
    route: '/params',
    name: 'Parámetros'
  },
  PROCESS: {
    route: '/process',
    name: 'Selección'
  },
  PURCHASE: {
    route: '/purchase',
    name: 'Comprar Tests'
  },
  CHECKOUT: {
    route: '/checkout',
    name: 'Checkout'
  },
  PAYMENT_SUCCESS: {
    route: '/payment-success',
    name: 'Pago Exitoso'
  },
  PAYMENT_FAILURE: {
    route: '/payment-failure',
    name: 'Pago Fallido'
  },
  PUBLIC_CHECKOUT: {
    route: '/comprar',
    name: 'Comprar'
  },
  GUEST_PAYMENTS: {
    route: '/pagos-pendientes',
    name: 'Pagos por asignar'
  },
  TEST_PREVIEW: {
    route: '/vista-previa-test',
    name: 'Vista previa del test'
  }
}

export const COLORS = {
  yellow: '#FFE600',
  blue: '#0021D1',
  red: '#FF0000',
  green: '#008D50',
  purple: '#DB00FF',
  lightblue: '#49C7EF',
  orange: '#FF6B00',
  petrol: '#009E9E',
  lightgreen: '#4CAF50',
  peachyellow: '#FFC645',
  burgundy: '#BA0021',
  darkyellow: '#8A6A00',
}

export const ERROR_MESSAGES = {
  session_expired: 'La sesión ha expirado'
}

export const PRICING = {
  IVA_RATE: 0.19,
};

